export function checkValidEmail(emailAddress: string) {
    const emailPattern = "[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,3}";
    const regex = new RegExp(emailPattern)

    if (emailAddress?.length) {
        return regex.test(emailAddress) ? true : false;
    }

    return true;
}
